export const API_BASE = "https://europe-west3-compass-gcp.cloudfunctions.net/Compass_Api_no_auth";
